import { ActionsHook } from "@/lib/Components/Actions/ActionGroupButtons";
import { ArchiveBoxIcon, DocumentTextIcon } from "@heroicons/react/20/solid";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { archiveWorkOrderMutation } from "@/app/ProDrivers/WorkOrders/GraphQL/workOrdersMutations";
import { useConfirmDeleteDialog } from "@/lib/Components/Dialog/Hooks/useConfirmDeleteDialog";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { PreviewPdfDialog } from "@/lib/Components/Dialog/PreviewPdfDialog";
import { useTranslations } from "use-intl";
import { WorkOrderStatus } from "@/gql/graphql";

const MANIFEST_VISIBLE_STATUSES: WorkOrderStatus[] = [
  WorkOrderStatus.AssigningDrivers,
  WorkOrderStatus.DriversAssigned,
  WorkOrderStatus.InProgress,
  WorkOrderStatus.Invoiced,
];

type WorkOrderActionsTarget = {
  id: string;
  status: WorkOrderStatus;
  manifest_url: string;
};

export function useWorkOrderActions(): ActionsHook<WorkOrderActionsTarget> {
  const { mutateAsync: archiveAsync } = useGqlMutation(
    archiveWorkOrderMutation,
  );
  const { open: openConfirmDialog } = useConfirmDeleteDialog();
  const { open: openPdfPreview } = useDialog(PreviewPdfDialog);
  const t = useTranslations("workOrder.actions");

  return (workOrder) => {
    const canViewManifest = MANIFEST_VISIBLE_STATUSES.includes(
      workOrder.status,
    );

    return [
      {
        label: t("actions"),
        items: [
          {
            actions: [
              {
                label: t("viewManifest"),
                Icon: DocumentTextIcon,
                color: "blue",
                isHidden: !canViewManifest,
                handleAction: () => {
                  openPdfPreview({
                    url: workOrder.manifest_url,
                  });
                },
              },
              {
                isHiddenTopBar: true,
                label: t("archive"),
                Icon: ArchiveBoxIcon,
                color: "purple",
                handleAction: async () => {
                  openConfirmDialog({
                    title: t("archiveTitle"),
                    message: t("archiveMessage"),
                    buttonText: t("archive"),
                    onDelete: () => {
                      archiveAsync({
                        id: workOrder.id,
                      });
                    },
                  });
                },
              },
            ],
          },
        ],
      },
    ];
  };
}
